import { render, staticRenderFns } from "./AddToFavoriteAction.vue?vue&type=template&id=26be31ae&"
import script from "./AddToFavoriteAction.vue?vue&type=script&lang=ts&"
export * from "./AddToFavoriteAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports